import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import CustomCollapsible from '../../ui/custom-collapsible/custom-collapsible';

interface FailedCheckItemProps {
    failedCheck: {
        policyName: string;
        level: string;
        reason: string;
    };
}

const FailedCheckItem: React.FC<FailedCheckItemProps> = ({ failedCheck }) => {
    return (
        <CustomCollapsible
            title={
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER} variant={[FONT_VARIANT.BOLD]}>
                    {failedCheck.policyName} - {failedCheck.level}
                </FontBody2>
            }
            isExpanded={false}
            level="tertiary"
        >
            <div className="failed-check-reason">
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                    {failedCheck.reason}
                </FontBody2>
            </div>
        </CustomCollapsible>
    );
};

export default FailedCheckItem;
